import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/dedupe';
import './stylesheets/PulsingCircle.scss';

export default function PulsingCircle(props) {
  const { className } = props;
  const classes = { loc: true, 'pulsing-circle': true };

  return (
    <div className={classNames(classes, className)} >
      <div className="double-bounce-1" />
      <div className="double-bounce-2" />
    </div>
  );
}

PulsingCircle.propTypes = {
  /** Applied to the PulsingCircle element */
  className: PropTypes.string
};



// WEBPACK FOOTER //
// ./node_modules/@localytics/loc-components/lib/PulsingCircle.jsx